import api from '../apiInstance'

export const getVouchers = (params, signal) =>
  api.get('/api/voucher/', {
    params,
    signal,
  })
